export default "__VITE_ASSET__72fd4ef6__"